import React, { FC, useState } from 'react';
import { Row, Spacer, Text, Column } from '@components/1-atoms';
import { AppTemplate } from '@components/4-templates';
import { PageHeader, Button, Info, IconButton } from '@components/2-molecules';
import { SubscriptionList } from '@components/3-organisms';


import { ForwardedPageProps } from '@lib/constants';
import { withForwardedNavigationParams } from 'react-navigation-props-mapper';
import { useUser } from '@lib/hooks/useUser';

import setTheme from '@lib/theme';

import subscription, { SubscriptionPackage } from '@lib/subscription';

import Stripe from '@assets/stripe';
import { useAppAlerts } from '@lib/hooks/base/useAppAlerts';

import { logout } from '@lib/service';

const theme = setTheme('light');


const Subscriptions: FC<ForwardedPageProps> = ({ navigation, ...props }) => {

    const [packages, setPackages] = useState<SubscriptionPackage[]>([]);
    const [selectedPackage, setSelectedPackage] = useState<SubscriptionPackage | null>(null);

    const alerts = useAppAlerts();

    // Set subscription packages
    React.useEffect(() => {
        const fetchPackages = async () => {
            const fetchedPackages: SubscriptionPackage[] = await subscription.getSubscriptionPackages();
            setPackages(fetchedPackages);
            setSelectedPackage(fetchedPackages[0]);

        };
        fetchPackages();
    }, []);

    // Purchase selected package
    const _purchase = () => { selectedPackage?.purchase(alerts.alert) };

    return (

        <AppTemplate hooks={[]}  gradiant={theme.gradients.white} >
            <Spacer h={2} /> 
            
            <Row>
                <Column>
                    <Text large>Subscriptions</Text>
                    <Spacer h={0.3} />
                    <Text color={"#7E7E7E"} small>Start with a free trial - no credit card required</Text>
                </Column>
                <Spacer w={1} />

                {/* <Icon /> */}
            </Row>
            <Spacer h={3} />

            <SubscriptionList
                color='#FFF'
                data={packages}
                defaultValue={selectedPackage}
                onPress={ (pkg) => setSelectedPackage(pkg) }
            />
            <Spacer h={6} />

            <Info align={'justify'}>
                The subscriptions are cancellable at anytime.{'\n'}
                You will still access your account information and data, even with an expired subscription for a limited period.{'\n'}
                After your Free Trial, an auto-renewable subscription will be activated for you. You can cancel your paid subscription before the end your trial period.{'\n'}
                We use Stripe to process your payment.{'\n'}
                Stripe is a certified PCI Service Provider Level 1. This is the most stringent level of certification available in the payments industry.{'\n'}
                Your subscription and auto-renewal can be managed by going to your Stripe, Apple Store, Google Play Store subscription portal if you are respectively using our Web, iOS or Android app.{'\n'}
                Stripe will send you an email that contains the link to access your subscription portal.{'\n'}
            </Info>
            <Spacer h={3} />

            <Button inset disabled={!selectedPackage} onPress={_purchase}>ENROLL</Button>
            <Spacer h={1} />

            <Button inset bg={'transparent'} color={"#CC0808"} onPress={logout}>LOGOUT</Button>
            <Spacer h={1} />
            
            <Spacer h={2} />
        </AppTemplate>
    );
};

export default withForwardedNavigationParams<ForwardedPageProps>()(Subscriptions);